<template>
	<div class="msg-dialog">
		<el-dialog :title="title" :visible.sync="visible" :width="dWidth" @closed="closeDialog" @open="openDialog"
			:destroy-on-close="true" :append-to-body="isAppend" center :top="dtop">
			<div class="md-content">
				<slot></slot>
			</div>
			<!-- <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </span>-->
		</el-dialog>
	</div>
</template>

<script>
	/**
	 * 外部引用组件
	 * <form-dialog :dialogVisible="dialogVisible" @closeDialog="closeDialog">$添加的内容$</form-dialog>
	 * 消息弹窗提示使用
	 * 将需要提示的内容添加到<slot></slot>中
	 * 确认取消需要添加的当前使用组件中
	 */
	export default {
		name: "FormDialog",
		props: {
			title: {
				type: String,
				default: "标 题"
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
			dWidth: {
				type: String,
				default: "400px"
			},
			dtop: {
				type: String,
				default: "0"
			},
			isAppend: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				visible: false
			};
		},
		methods: {
			// 弹窗关闭时调用
			closeDialog() {
				this.$emit('closeDialog');
			},
			// 弹窗开启时调用
			openDialog() {

			},
			// beforClose(){
			// 	this.visible = false;
			// 	this.$emit('beforClose')
			// }
			// 弹窗关闭时回调，会暂停 Dialog 的关闭
			// handleClose() {
			// 	this.visible = false;
			// 	console.log('66666');
			// 	this.$emit('closeDialog');
			// }
		},
		watch: {
			dialogVisible() {
				this.visible = this.dialogVisible;
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog {
		margin: 0px;
		border-radius: 8px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	/deep/ .el-dialog__header {
		padding: 16px;
		border-radius: 8px 8px 0px 0px;
		// background-image: linear-gradient(270deg,
		// 		#86eae7 0%,
		// 		#4cccf0 45%,
		// 		#11adf8 100%),
		// 	linear-gradient(#ffffff, #ffffff);
		// background-blend-mode: normal, normal;
		background-color: var(--theme-color-customized-1);

		.el-dialog__title {
			font-size: 20px;
			color: #fff;
		}
	}

	.msg-dialog {

		/deep/ .el-dialog {
			margin: 0px;
			border-radius: 8px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		/deep/ .el-dialog__header {
			padding: 16px;
			border-radius: 8px 8px 0px 0px;
			// background-image: linear-gradient(270deg,
			// 		#86eae7 0%,
			// 		#4cccf0 45%,
			// 		#11adf8 100%),
			// 	linear-gradient(#ffffff, #ffffff);
			// background-blend-mode: normal, normal;
			background-color: var(--theme-color-customized-1);

			.el-dialog__title {
				font-size: 20px;
				color: #fff;
			}
		}

		/deep/ .el-dialog__body {
			padding: 16px;
			overflow: hidden;
		}

		/deep/ .el-dialog__footer {
			padding: 0px 16px 16px;
			border-radius: 0px 0px 8px 8px;

			/deep/ .el-button+.el-button {
				margin-left: 20px;
			}
		}

		.md-content {
			/deep/ .form-dialog {
				padding-right: 30px;

				.el-form {
					/deep/ .el-input__inner {
						border-radius: 20px;
					}

					.el-form-item {
						margin-bottom: 0px;
					}

					.el-form-item+.el-form-item {
						margin-top: 22px;
					}

					/deep/ .el-form-item__content {
						.el-button {
							margin-left: -5px;
						}

						.el-button+.el-button {
							margin-left: 20px;
						}
					}
				}
			}
		}
	}
</style>
